
import React from 'react';

export const StrategyExplanation: React.FC = () => {
  return (
    <div className="bg-card border border-border rounded-2xl p-4 sm:p-6 shadow-lg">
      <div className="text-center mb-4 sm:mb-6">
        <h2 className="text-xl sm:text-2xl font-bold text-primary mb-2 flex items-center justify-center space-x-2">
          <span>💡</span>
          <span>Chiến Lược Mô Hình 1-3-6</span>
        </h2>
        <p className="text-sm sm:text-base text-muted-foreground">Hiểu rõ cách thức hoạt động trước khi tính toán</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
        <div className="bg-secondary p-3 sm:p-4 rounded-xl text-center min-h-[120px] sm:min-h-[140px] flex flex-col justify-center">
          <div className="text-2xl mb-2">1️⃣</div>
          <div className="text-tradebrand-green font-semibold mb-2 text-sm sm:text-base">RÚT RA (10%)</div>
          <div className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
            Rút 10% lợi nhuận AI Prop để tạo cash flow ổn định hàng tháng
          </div>
        </div>
        
        <div className="bg-secondary p-3 sm:p-4 rounded-xl text-center min-h-[120px] sm:min-h-[140px] flex flex-col justify-center">
          <div className="text-2xl mb-2">3️⃣</div>
          <div className="text-tradebrand-blue font-semibold mb-2 text-sm sm:text-base">TÁI ĐẦU TƯ (30%)</div>
          <div className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
            Mua vé thi mới để mở rộng quy mô vốn được cấp liên tục
          </div>
        </div>
        
        <div className="bg-secondary p-3 sm:p-4 rounded-xl text-center min-h-[120px] sm:min-h-[140px] flex flex-col justify-center sm:col-span-2 lg:col-span-1">
          <div className="text-2xl mb-2">6️⃣</div>
          <div className="text-primary font-semibold mb-2 text-sm sm:text-base">BOT TRADING (60%)</div>
          <div className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
            Giao dịch tiền thật với 10%/tháng, tích lũy theo thời gian
          </div>
        </div>
      </div>

      <div className="mt-4 sm:mt-6 bg-secondary border border-border p-3 sm:p-4 rounded-xl">
        <div className="flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-4 text-xs sm:text-sm">
          <div className="flex items-center space-x-2">
            <span className="text-primary">⏰</span>
            <span className="text-muted-foreground">Mỗi vòng = 3 tháng</span>
          </div>
          <div className="hidden sm:block w-px h-4 bg-border"></div>
          <div className="flex items-center space-x-2">
            <span className="text-tradebrand-green">🎯</span>
            <span className="text-muted-foreground">AI Prop: 5%/tháng × 80% giữ lại</span>
          </div>
          <div className="hidden sm:block w-px h-4 bg-border"></div>
          <div className="flex items-center space-x-2">
            <span className="text-tradebrand-blue">🤖</span>
            <span className="text-muted-foreground">Bot: 10%/tháng tích lũy</span>
          </div>
        </div>
      </div>
    </div>
  );
};
